interface TimerOptions<T> {
  options?: T
  color?: string
  prefix?: string
  enabled?: boolean
}

// Internal basic logic
function _createTimer<T>(label: string, settings: TimerOptions<T>) {
  const { enabled = true, color = '#0a0', prefix = 'Performance', options } = settings

  if (!enabled) {
    return { diff: () => 0, end: () => '0' }
  }

  const start = performance.now()
  const diff = () => performance.now() - start

  return {
    diff,
    end(extraInfo = ''): string {
      const duration = diff().toFixed(2)
      const labelStr = `%c[${prefix}] ${label}: ${duration} ms ${extraInfo}`
      const style = `color: ${color}; font-weight: bold;`

      if (options !== undefined) {
        console.groupCollapsed(labelStr, style)
        console.log('Context:', options)
        console.groupEnd()
      } else {
        console.log(labelStr, style)
      }

      return duration
    },
  }
}

// Global timer - Controlled via the Runtime Config
export function createPerfTimer<T = unknown>(label: string, options?: T) {
  const runtimeConfig = useRuntimeConfig()
  return _createTimer(label, {
    options,
    enabled: runtimeConfig.public.enablePerfLogs,
    color: '#0a0',
    prefix: 'Performance',
  })
}

// Local timer - Always active, color customizable
export function createPerfTimerLocal<T = unknown>(label: string, options?: T, color = '#3498db') {
  return _createTimer(label, {
    options,
    enabled: true,
    color,
    prefix: 'Performance Local',
  })
}
